// extracted by mini-css-extract-plugin
export default {"productCarousel":"x1-z"};